import { stat } from "fs";

const route = {
  state: {
    data: []
  },
  mutations: {
      ADD_VIEW_ROUTE: (state, view) => {
        if(state.data.some(v => v.path === view.path)) return
        state.data.push({
          path: view.path,
          title: view.meta.tagTitle || '长江院CRM'
        })
      },
      DEL_VIEW_ROUTE: (state, path) => {
        for (const [i, v] of state.data.entries()){
          if(v.path === path) {
            state.data.splice(i, 1)
            break
          }
        }
      },
      CLEAR_VIEW_ROUTE: (state, view) => {
        state.data = []
        if(view.path==='/dashboard/index'){

        }else{
          state.data.push({
            path: view.path,
            title: view.meta.tagTitle || '长江院CRM'
          })
        }
      }
  }
}

export default route



// WEBPACK FOOTER //
// ./src/store/modules/viewRoute.js